/**
 * @param {*} locked — value from API (boolean, 0/1, "0"/"1")
 */
export function isCompanyLockedFlag(locked) {
  return locked === true || locked === 1 || locked === "1";
}

/** @param {*} $auth — vue-auth instance (this.$auth) */
export function getAuthUserCompany($auth) {
  if (!$auth) return null;
  const user = $auth.user();
  if (!user || typeof user !== "object" || !user.company) return null;
  return user.company;
}

/** @param {*} $auth — vue-auth instance (this.$auth) */
export function isAuthUserCompanyLocked($auth) {
  const company = getAuthUserCompany($auth);
  if (!company) return false;
  return isCompanyLockedFlag(company.locked);
}
